module.exports = __webpack_public_path__ + "img/ic_team_website_white.73b70c14.svg";